module.exports = __webpack_public_path__ + "img/oak-model-sample15-aerial.b1bd0364.png";